import type { ComponentProps, ReactNode } from "react";
import { IconChevronDown } from "./icons";

// Form alanları: yerel <select>/<input> (klavye, ekran okuyucu, mobil seçici yerel), marka biçimiyle (.field, globals.css).
// Hook kullanmaz: sunucu ve istemci bileşenlerinde kullanılabilir.

export function FieldLabel({ htmlFor, children, hint }: { htmlFor: string; children: ReactNode; hint?: ReactNode }) {
  return (
    <label htmlFor={htmlFor} className="text-sm font-semibold text-ink">
      {children}
      {hint && <span className="block text-xs font-normal text-ink-muted">{hint}</span>}
    </label>
  );
}

/** Biçimli yerel select: sağda ok simgesi (dekoratif, tıklamayı engellemez) */
export function Select({ className = "", children, ...props }: ComponentProps<"select">) {
  return (
    <div className="relative min-w-0">
      <select className={`field ${className}`} {...props}>
        {children}
      </select>
      <IconChevronDown size={18} className="pointer-events-none absolute top-1/2 right-3.5 -translate-y-1/2 text-ink" />
    </div>
  );
}

export function Input({ className = "", ...props }: ComponentProps<"input">) {
  return <input className={`field ${className}`} {...props} />;
}
